// extracted by mini-css-extract-plugin
export default {"formField":"Ipa-z","error":"Jpa-z","disabled":"Kpa-z","fieldError":"Lpa-z","errorText":"Mpa-z","button":"Npa-z","acknowledgment":"Opa-z"};